import eventHandlerMutations from "./mutations.js";
import eventHandlerActions from "./actions.js";
import eventHandlerGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      selectedImage: {},
      isImageListWindowOpen: false
    };
  },
  mutations: eventHandlerMutations,
  actions: eventHandlerActions,
  getters: eventHandlerGetters,
};
